
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./live_monitoring_extension": () => {
return Promise.all([__webpack_require__.e("3656"), __webpack_require__.e("9710"), __webpack_require__.e("186"), __webpack_require__.e("5108"), __webpack_require__.e("4225")]).then(() => (() => (__webpack_require__(2073))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };